import { refs, domReady, dispatchEvent } from '../modules/utils.js';
import { animate, utils } from 'animejs';

class IconInfo extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();

    setTimeout(() => this.#tweenIn(), 0);
  }

  #listeners() {
    this.addEventListener('click', (e) => dispatchEvent('iconinfo:click'));
  }

  #tweenIn() {
    this.classList.add('display');

    animate(
      this,
      {
        opacity: [0, 1],
        rotate: '1turn',
        ease: 'inOutQuad',
        duration: 1200,
        onComplete: utils.cleanInlineStyles
      }
    );
  }
}

customElements.define('icon-info', IconInfo);
